export default docsUrl => {
  window.location.assign(
    `${docsUrl}/signin?immediate=true&ui_mode=iframe&source=matrix&redirect=${encodeURIComponent(
      window.location.href
    )}`
  );
};
